export default "__VITE_ASSET__D$jtCCUw__"